export const COMPANY = {
  name: "CompuBrain AI",
  parent: "CompuBrain",
  domain: "compubrain.ai",
  tagline: "Generative Engine Optimization Consulting",
  legalAddress: "CompuBrain House, Anjali Society #8, Maninagar, Ahmedabad, Gujarat 380008, India",
  city: "Ahmedabad",
  region: "Gujarat",
  country: "India",
  geo: { lat: 22.9909537, lng: 72.6007265 },
  phone: "+91 95121 50000",
  phoneHref: "tel:+919512150000",
  email: "info@compubrain.in",
  salesEmail: "sales@compubrain.in",
  whatsapp: "http://api.whatsapp.com/send?phone=+917574850000&text=Hi,%20I%20would%20like%20to%20talk%20about%20GEO%20services",
  hours: "Mon – Sat, 10:00 AM – 7:00 PM IST",
  logo: "https://customer-assets-39nsmqrw.emergentagent.net/job_fb131322-bc52-460b-86fc-c10bf4fad142/artifacts/q19dz799_CB_logo_v15.webp",
  monogram: "https://customer-assets-39nsmqrw.emergentagent.net/job_fb131322-bc52-460b-86fc-c10bf4fad142/artifacts/wb713ma5_CB_monogram_.webp",
  social: {
    linkedin: "https://www.linkedin.com/company/compubrain",
    twitter: "https://twitter.com/compubrain",
    instagram: "https://www.instagram.com/compubrain/",
    facebook: "https://www.facebook.com/CompuBrain",
  },
};

export const STATS = [
  { value: "5300+", label: "Clients Served" },
  { value: "20+", label: "Years of Experience" },
  { value: "16+", label: "Industries" },
  { value: "7", label: "AI Platforms Optimized" },
];

export const NAV = [
  { label: "Services", to: "/services" },
  { label: "Industries", to: "/industries" },
  { label: "AI Visibility Tool", to: "/tools" },
  { label: "Blog", to: "/blog" },
  { label: "Glossary", to: "/glossary" },
  { label: "About", to: "/about" },
];

export const CTA_VARIANTS = [
  "Request AI Visibility Audit",
  "Schedule Strategy Call",
  "Talk to a GEO Expert",
  "Get Custom GEO Roadmap",
];
